﻿/**
 * Scroll functionality
 *
 *
 * @class rlScroll
 * @memberOf jQuery.fn
 */

(function($) {

    $.fn.rlScroll = function() {

        //Fixed CTA scroll functionality

        //Set timeout on scroll checking
        var scrollTimer = null;
        $(window).scroll(function() {
            if (scrollTimer) {
                clearTimeout(scrollTimer); // clear any previous pending timer
            }
            scrollTimer = setTimeout(scrolling, 200); // set new timer
        });

        //scroll funtion to check if footer is in viewport & Bring in Fixed CTA on scroll
        function scrolling() {
            scrollTimer = null;

            var top_of_element = $("#footer").offset().top;
            var bottom_of_element = $("#footer").offset().top + $("#footer").outerHeight();
            var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
            var top_of_screen = $(window).scrollTop();

            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) || ($(document).scrollTop() < 200)) {
                $('.fixed-cta-btn').removeClass('bring-it');
            } else {
                $('.fixed-cta-btn').addClass('bring-it');
            }

        }

    }

}(jQuery));